import { memo } from 'react';

import { WorkspaceHeaderInformationDropdown } from '~/components/v2/components/workspace/workspace-header/WorkspaceHeaderInformationDropdown';
import { WorkspaceHeaderInformationLogo } from '~/components/v2/components/workspace/workspace-header/WorkspaceHeaderInformationLogo';

export const WorkspaceHeaderInformation = memo(() => {
  return (
    <div className="relative z-40 flex min-w-0 max-w-[var(--sidebar-width)] shrink items-center gap-1 px-4">
      <WorkspaceHeaderInformationLogo />
      <WorkspaceHeaderInformationDropdown />
    </div>
  );
});

WorkspaceHeaderInformation.displayName = 'WorkspaceHeaderInformation';
